import clamp from 'lodash/clamp'
import type {
  PhotoPetData,
  RemotePhoto,
} from 'components/PhotoBank/PhotoBank.types'
import type { ThumbCrop } from 'stores/cartStore/CartItem'
import { TILE_BEFORE_AFTER_SOURCE_PHOTO_SIZE_PX } from '../cartUpsells.consts'

export function getPetThumbCrop(
  petBox: Pick<PhotoPetData, 'x' | 'y' | 'width' | 'height'>,
  photo: Pick<RemotePhoto, 'width' | 'height'>
): ThumbCrop {
  const aspectRatio =
    TILE_BEFORE_AFTER_SOURCE_PHOTO_SIZE_PX.width /
    TILE_BEFORE_AFTER_SOURCE_PHOTO_SIZE_PX.height
  const petFitWidthPx = Math.max(
    petBox.width * photo.width,
    petBox.height * photo.height * aspectRatio
  )
  const widthPx = Math.min(
    petFitWidthPx,
    photo.width,
    photo.height * aspectRatio
  )
  const heightPx = widthPx / aspectRatio
  const leftPx = clamp(
    (petBox.x + petBox.width / 2) * photo.width - widthPx / 2,
    0,
    photo.width - widthPx
  )
  const topPx = clamp(
    (petBox.y + petBox.height / 2) * photo.height - heightPx / 2,
    0,
    photo.height - heightPx
  )
  return {
    xRatio: leftPx / photo.width,
    yRatio: topPx / photo.height,
    widthRatio: widthPx / photo.width,
    heightRatio: heightPx / photo.height,
  }
}
